<template>
  <div class="sonar-card sonar-card">
    <div class="sonar-card__wrapper">
      <SonarProgressCard
        class="sonar-card__progress"
        v-bind="{ currentScore }"
      />
      <div class="sonar-card__info-wrapper">
        <h4 class="sonar-card__status">
          {{ statusLabel }}
        </h4>
        <!-- To be implemented when the response is ready  -->
        <!-- <h6 class="sonar-card__rating">
          {{ expertiseLabel }}
        </h6>
        <div class="pill pill--proficiency">
          Novice
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import SonarProgressCard from '@/sonar/components/SonarProgressCard.vue'

export default {
  name: 'SonarCard',
  components: {
    SonarProgressCard,
  },
  props: {
    currentScore: {
      type: Object,
      required: true,
    },
    isResultsModal: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    statusLabel() {
      return `${this.currentScore.name}`
    },
    expertiseLabel() {
      return `${this.currentScore.name} average expertise rating:`
    },
  },
}
</script>

<style lang="scss" scoped>
.sonar-card {
  position: relative;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  min-height: 247px;
  width: 100%;
  max-width: 503px;
  border-radius: 10px 0 0 10px;
  justify-content: center;
  padding: 40px 0 20px;
  @include tablet {
    padding: 20px 0;
  }
  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10;
    max-width: 364px;
    text-align: center;
  }
  &__info-wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 7px;
  }
  &__status {
    color: var(--white);
    font-size: rem(20);
    line-height: rem(26);
    font-family: var(--font-bold);
    margin: 0;
    @include mobile {
      font-size: rem(24);
      line-height: rem(32);
    }
  }
  &__rating {
    color: var(--white);
    margin: 0;
    font-size: rem(16);
    line-height: rem(23);
  }
  &__progress {
    margin: 0 0 12px;
    width: 133px;
    height: 133px;
    @include tablet {
      margin: 0 0 17.5px;
      height: 167px;
      width: 167px;
    }
  }
  &--results {
    background-size: 186%;
    background-position: 52% 61%;
    width: 364px;
    min-width: 364px;
    min-height: 468px;
  }
}
</style>
